/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
var Dispatcher = require('./dispatcher');
var assign = require('object-assign');

var AppDispatcher = assign({}, Dispatcher.prototype, {

  /**
   * A bridge function between the views and the dispatcher, marking the action
   * as a view action.  Another variant here could be handleServerAction.
   * @param  {object} action The data coming from the view.
   */
  handleViewAction: function(action) {
    this.dispatch({
      source: 'VIEW_ACTION',
      action: action
    });
  }

});

module.exports = AppDispatcher;


// WEBPACK FOOTER //
// ./src/app/dispatcher/AppDispatcher.js